import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { languages, setStoredLang, type LangCode } from '../i18n';
import './LanguageSwitcher.css';

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const current = languages.find((l) => l.code === i18n.language) || languages[0];

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, []);

  return (
    <div className="lang-dropdown" ref={ref}>
      <button
        type="button"
        className="lang-dropdown-trigger"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        aria-haspopup="listbox"
      >
        <span className="lang-dropdown-label">{current.label}</span>
        <span className="lang-dropdown-arrow">{open ? '▲' : '▼'}</span>
      </button>
      {open && (
        <ul className="lang-dropdown-menu" role="listbox">
          {languages.map(({ code, label }) => (
            <li key={code} role="option">
              <button
                type="button"
                className={`lang-dropdown-item ${i18n.language === code ? 'active' : ''}`}
                onClick={() => {
                  setStoredLang(code as LangCode);
                  setOpen(false);
                }}
              >
                {label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default LanguageSwitcher;
